<template>
  <div :class="[$style.root, { [$style.fill]: fill }]">
    <slot />
    <div v-if="active" :class="$style.overlay">
      <span :class="$style.spinner" aria-hidden="true"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SectionLoader",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" module>
.root {
  position: relative;
  min-width: 0;
}

.fill {
  flex: 1 1 auto;
  min-height: 12rem;
}

.overlay {
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 8rem;
  background: $bg-white-opacity;
  pointer-events: all;
}

.spinner {
  flex: 0 0 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: conic-gradient(from 90deg, $orange 0deg, $bg-primary 360deg);
  -webkit-mask: radial-gradient(
    farthest-side,
    transparent calc(100% - 0.2rem),
    #000 0
  );
  mask: radial-gradient(farthest-side, transparent calc(100% - 0.2rem), #000 0);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(1turn);
  }
}
</style>
